import React from "react";
import "./ProviderModal.css";

const formatDate = (dateString) => {
    if (!dateString) return "";
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return new Date(dateString).toLocaleDateString("en-GB", options);
  };

const ProviderModal = ({ transactionData, setShowModal,startDate,endDate,userName }) => {

    // console.log("statDate:::",startDate)
    // console.log("endDate:::",endDate)
    // console.log("userName:::",userName)
    const formattedStartDate = formatDate(startDate);
    const formattedEndDate = formatDate(endDate);

  return (
    <div className="form-balance-container">
    <div className="modal-overlay">
      <div className="modal">
        <h3><span className="name-users">{userName}</span> 's Provider Merchant Details</h3>
        <h5 className="date-range">Selected Date Range :  <span className="name-users">{formattedStartDate} - {formattedEndDate}</span></h5>
        <div className="table-modal-main-div">
        <table className="table-wallet-management">
          <thead className="table-modal-header"> 
            <tr className="table-modal-tr">
              <td>S.No</td>
              <td>Merchant Name</td>
              <td>Provider Name</td>
              <td>Business Name</td>
              <td>Type</td>
              <td>Amount</td>
            </tr>
          </thead>
          <tbody>
            {transactionData && transactionData.length > 0 ? (
              transactionData.map((item, index) => (
                <tr className="table-user-data" key={index}>
                  <td>{index + 1}</td>
                  <td>{item.userName || "N/A"}</td>
                  <td>{item.pg || "N/A"}</td>
                  <td>{item.orgName || "N/A"}</td>
                  <td>{item.type || "N/A"}</td>
                  <td>{Number(item.totalAmount).toFixed(2) || "N/A"}</td>
                </tr>
              ))
            ) : (
              <tr><td colSpan="6" className="no-found-value">No Transaction available.</td></tr>
            )}
          </tbody>
        </table>

        <div className="modal-buttons">
          <button type="button" onClick={() => setShowModal(false)} style={{backgroundColor:'#e96e17'}}>Cancel</button>
        </div>
      </div>
      </div>
    </div>
    </div>
  );
};

export default ProviderModal;
